import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ReimbursementCosts } from '../../model/reimbursementcosts';
@Component( {
    selector: 'erp-businesstripapplication-reimbursement-costs',
    templateUrl: './businesstripapplication-reimbursement-costs.component.html'
} )
export class BusinesstripApplicationReimbursementCostsComponent {
    @Input() reimbursementCosts: ReimbursementCosts = new ReimbursementCosts();
    @Output() readonly reimbursementCostsChange: EventEmitter<ReimbursementCosts> = new EventEmitter<ReimbursementCosts>();

    constructor() { }

    onModelChange( changedValue: number | boolean ) {
        this.reimbursementCostsChange.emit( this.reimbursementCosts );
    }
}
